export enum SALES_STATE {
  SALE_PAUSED = "SALE_PAUSED",
  SALE_NOT_STARTED = "SALE_NOT_STARTED",
  SALE_OVER = "SALE_OVER",
  SOLD_OUT = "SOLD_OUT",
  SALE_STARTED = "SALE_STARTED",
}
